import React, { Component } from "react";
import PropTypes from "prop-types";
import SearchMenu from "./SearchMenu";
import { ItemMeta, MediaItem, MediaBody } from "@zendeskgarden/react-menus";
import gql from "graphql-tag";
import { Query } from "react-apollo";

import styles from "./styles.css";

const authorsQuery = gql`
  query Authors($name: String) {
    authors(filter: { role: [MANAGER, ADMIN, AGENT] }, query: { name: $name }) {
      edges {
        node {
          id
          name
          email
        }
      }
    }
  }
`;

export default class AuthorMenu extends Component {
  static propTypes = {
    getItemProps: PropTypes.func.isRequired,
    focusedKey: PropTypes.string,
  };

  state = { searchText: "" };

  onSearchTextChanged = searchText => {
    this.setState({ searchText });
  };

  render() {
    const { searchText } = this.state;
    const { getItemProps, focusedKey } = this.props;

    return (
      <SearchMenu>
        <SearchMenu.Input onChange={this.onSearchTextChanged} />
        <Query query={authorsQuery} variables={{ name: searchText }}>
          {({ loading, error, data }) => {
            if (error) return <SearchMenu.SearchFailure />;

            const { authors = { edges: [], total: 0 } } = data;

            return (
              <SearchMenu.Items>
                {authors.edges.map(({ node: { id, name, email } }) => (
                  <MediaItem
                    {...getItemProps({
                      key: `author-${id}`,
                      focused: focusedKey === `author-${id}`,
                    })}
                    data-test-id={`filter-menu-author-item-${id}`}
                  >
                    <MediaBody>
                      {name}
                      <ItemMeta className={styles.authorEmail}>
                        {email}
                      </ItemMeta>
                    </MediaBody>
                  </MediaItem>
                ))}
              </SearchMenu.Items>
            );
          }}
        </Query>
      </SearchMenu>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FilterMenu/AuthorMenu.js